import React from 'react';
import { User, Mail, Building, Phone, FileText, X } from "lucide-react";

const PublisherDetails = ({ publisher, onToggleInvoice, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
                <div className="flex justify-between items-center border-b p-4">
                    <h2 className="text-xl font-semibold text-gray-800">Publisher Details</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        <X size={20} />
                    </button>
                </div>

                <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                    <DetailItem icon={<User size={18} className="text-blue-500" />} label="Name" value={publisher.name} />
                    <DetailItem icon={<Mail size={18} className="text-blue-500" />} label="Email" value={publisher.email} />
                    <DetailItem icon={<Building size={18} className="text-blue-500" />} label="Company" value={publisher.company} />
                    <DetailItem icon={<Phone size={18} className="text-blue-500" />} label="Phone" value={publisher.phone} />
                    <DetailItem
                        icon={<FileText size={18} className="text-blue-500" />}
                        label="Invoice Status"
                        value={publisher.isInvoiceEnable ? 'Enabled' : 'Disabled'}
                        status={publisher.isInvoiceEnable}
                    />
                </div>

                <div className="bg-gray-50 px-6 py-4 border-t flex justify-end space-x-3">
                    <button
                        onClick={() => onToggleInvoice(publisher.id, publisher.isInvoiceEnable)}
                        className={`px-4 py-2 rounded-md ${publisher.isInvoiceEnable
                                ? 'bg-red-100 text-red-700 hover:bg-red-200'
                                : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                            }`}
                    >
                        {publisher.isInvoiceEnable ? 'Disable Invoice' : 'Enable Invoice'}
                    </button>
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

const DetailItem = ({ icon, label, value, status }) => (
    <div className="flex items-start space-x-3">
        <div className="mt-1">{icon}</div>
        <div>
            <p className="text-sm font-medium text-gray-500">{label}</p>
            <p className={`mt-1 text-lg font-semibold ${status === false ? 'text-red-600' :
                    status === true ? 'text-green-600' :
                        'text-gray-800'
                }`}>
                {value}
            </p>
        </div>
    </div>
);

export default PublisherDetails;